import { render, staticRenderFns } from "./adgroupVideoProfile.vue?vue&type=template&id=56ed99c2&scoped=true&"
import script from "./adgroupVideoProfile.vue?vue&type=script&lang=js&"
export * from "./adgroupVideoProfile.vue?vue&type=script&lang=js&"
import style0 from "./adgroupVideoProfile.vue?vue&type=style&index=0&id=56ed99c2&lang=css&scoped=true&"
import style1 from "./adgroupVideoProfile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ed99c2",
  null
  
)

export default component.exports